module.exports = __webpack_public_path__ + "img/ico_servico-indisponivel.b640ea3e.svg";